import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { soldApi, imageUrl } from "../lib/api";
import { Calendar, Gauge, Fuel, ArrowRight } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

export default function Sold() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    soldApi.list().then(setItems).finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-[#1a1a1a] text-white min-h-screen">
      <Navbar />

      <section className="pt-[140px] pb-12 px-5 lg:px-8">
        <div className="max-w-[1200px] mx-auto text-center">
          <div className="text-[#c5a76f] text-sm tracking-[0.3em] uppercase mb-4">{t("sold.overline")}</div>
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-5" style={{ fontFamily: "'Familjen Grotesk', serif" }}>
            {t("sold.title")} <span className="text-[#c5a76f]">{t("sold.titleAccent")}</span> {t("sold.titleEnd")}
          </h1>
          <p className="text-white/70 max-w-2xl mx-auto">
            {t("sold.intro")}
          </p>
        </div>
      </section>

      <section className="px-5 lg:px-8 pb-24">
        {loading ? (
          <div className="text-center text-white/40 py-20">{t("common.loading")}</div>
        ) : (
          <div className="max-w-[1400px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((c) => (
              <div key={c.id} className="group relative bg-[#242424] rounded-md overflow-hidden border border-white/5">
                <div className="relative aspect-[4/3] overflow-hidden">
                  {c.image && <img src={imageUrl(c.image, { thumb: true })} alt={c.title} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700" />}
                  <div className="absolute inset-0 bg-black/30" />
                  <div className="absolute top-4 right-4 bg-red-600/90 text-white text-xs font-bold tracking-widest px-3 py-1 rounded">{t("sold.sold")}</div>
                </div>
                <div className="p-5">
                  <h3 className="text-white text-lg font-semibold">{c.title}</h3>
                  <div className="grid grid-cols-3 gap-2 mt-4 text-xs text-white/60">
                    <div className="flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5 text-[#c5a76f]" /> {c.year}</div>
                    <div className="flex items-center gap-1.5"><Gauge className="w-3.5 h-3.5 text-[#c5a76f]" /> {c.km?.toLocaleString()} km</div>
                    <div className="flex items-center gap-1.5"><Fuel className="w-3.5 h-3.5 text-[#c5a76f]" /> {c.fuel}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="max-w-[800px] mx-auto mt-16 text-center bg-[#242424] border border-[#c5a76f]/30 rounded-md p-10">
          <h2 className="text-2xl md:text-3xl text-white font-bold mb-4" style={{ fontFamily: "'Familjen Grotesk', serif" }}>
            {t("sold.ctaTitle")}
          </h2>
          <p className="text-white/70 mb-7">
            {t("sold.ctaText")}
          </p>
          <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-3.5 bg-[#c5a76f] text-black hover:bg-[#d8bd86] transition-colors text-sm font-semibold tracking-widest uppercase rounded">
            {t("sold.contactUs")} <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
